import { render, staticRenderFns } from "./StudentTypeNewDialogButton.vue?vue&type=template&id=3bb8e9be"
import script from "./StudentTypeNewDialogButton.vue?vue&type=script&lang=js"
export * from "./StudentTypeNewDialogButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports